export default __webpack_public_path__ + "static/media/yellow-success.3096511f.svg";